import * as actionTypes from "../actions/actionTypes.js";

const initialState = {
    languageItemList:[]

};



export default function languageItem(state = initialState, action) {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case actionTypes.GET_LANGUAGE_ITEM_SECCUSS :
            return Object.assign({}, state, {languageItemList: action.payload});
        default:
            return state;
    }
}
